export default {"src":"/_next/static/media/stressMotivation.ba5809e3.svg","height":646,"width":1048,"blurWidth":0,"blurHeight":0};